<ng-container *transloco="let t; prefix: 'sideNav.menu'">
  <div class="mx-6 flex h-full items-center" [class.collapsed]="collapsed()">
    <button
      type="button"
      class="mr-0 flex w-full items-center rounded-md px-4 py-2 text-steel-100 hover:bg-blue-10 hover:text-blue-50"
      (click)="switchUser()"
    >
      @if (!collapsed()) {
        @if (hasMultipleProfiles()) {
          <span class="text-left">{{ t('switchAccounts') }}</span>
        } @else {
          <span class="text-left"> {{ t('accountModal', { name: name() | possessive }) }} </span>
        }
        <rma-icon class="ml-auto" [glyph]="icon()" />
      } @else {
        <rma-avatar
          class="shrink-0"
          [avatar]="profile().profileImage"
          [name]="profile().fullName"
          [backgroundColour]="backgroundColour()"
          [title]="t('accountModal', { name: name() | possessive })"
        />
      }
    </button>
  </div>
</ng-container>
